module.exports = __webpack_public_path__ + "static/the-paris-architect-cbb38002702635cf794a082e0c72946f.jpg";